import Cookies from 'js-cookie'
import { USER_INFO } from '@/constants/auth'
import { NO_SOURCE_MODAL_KEY, TRIAL_EXPIRED_MODAL_KEY } from '@/constants/app'

export default defineNuxtPlugin({
  name: 'cookies',
  setup() {
    const expires = 365

    return {
      provide: {
        cookies: {
          get(key: string): string {
            const value = Cookies.get(key)
            if (value) {
              try {
                return JSON.parse(value)
              } catch {
                return value
              }
            }
          },

          set(
            key: string,
            content: string | object,
            options: Cookies.CookieAttributes = {},
          ) {
            Cookies.set(key, JSON.stringify(content), { expires, ...options })
          },

          remove(key: string) {
            Cookies.remove(key)
          },

          removeCookies() {
            const cookies = Cookies.get()
            Object.keys(cookies).forEach((key) => {
              Cookies.remove(key)
            })
          },

          setTrialExpiredCookie() {
            this.set(TRIAL_EXPIRED_MODAL_KEY, null)
          },

          trialExpiredCookieExists(): boolean {
            return (
              this.get(TRIAL_EXPIRED_MODAL_KEY) !== undefined ||
              this.get(TRIAL_EXPIRED_MODAL_KEY) !== null
            )
          },

          setNoSourceSubscriptionCookie() {
            this.set(NO_SOURCE_MODAL_KEY, null)
          },

          noSourceSubscriptionCookieExists(): boolean {
            return (
              this.get(NO_SOURCE_MODAL_KEY) !== undefined ||
              this.get(NO_SOURCE_MODAL_KEY) !== null
            )
          },

          getUserInfo() {
            return this.get(USER_INFO)
          },
        },
      },
    }
  },
})
